import { ROUTER_API } from 'app/constants/api.constant';
import axios from 'axios';
import { StripePaymentLink, StripeProduct, StripeSubscription } from './types';

export const axiosStripe = axios.create();
axiosStripe.defaults.baseURL = ROUTER_API;

axiosStripe.interceptors.request.use(
  request => {
    // Edit request config
    return {
      ...request,
      params: {
        ...request.params,
        token: request.headers?.common?.Authorization,
      },
    };
  },
  error => {
    return Promise.reject(error);
  },
);

export const getStripeUrlSession = async () => {
  const { data } = await axiosStripe.post(`/stripe/customer-portal`);
  const sessionUrl: string = await data.url;

  return sessionUrl;
};

export const getStripePaymentLinks = async () => {
  const { data } = await axiosStripe.get<StripePaymentLink[]>(`/stripe/payment-links`);
  return data;
};

export const getStripePaymentLinkById = async (pLinkId: string, userId: string) => {
  const { data } = await axiosStripe.get<StripePaymentLink>(`/stripe/payment-links/${pLinkId}`, {
    params: {
      userId,
    },
  });
  return data;
};

export const getStripeProducts = async () => {
  const { data } = await axiosStripe.get<{ data: StripeProduct[] }>(`/stripe/products`);
  return data.data;
};

export const getStripeProductById = async (stripeId: string) => {
  const { data } = await axiosStripe.get<{ data: StripeProduct[] }>(`/stripe/products`);
  return data.data.find(product => product.id === stripeId);
};

export const getStripeSubscriptions = async (userId: string) => {
  const { data } = await axiosStripe.get<StripeSubscription>(`/stripe/subscriptions`, {
    params: {
      userId,
    },
  });
  return data;
};
